import { createAsyncThunk } from "@reduxjs/toolkit";
import { createDynamicThunk } from ".";
import APICaller from "../../utils/APICaller";

/**
 * LIST Audits
 */
export const fetchAuditsThunk = createDynamicThunk({
  typePrefix: "audits/fetchAuditsThunk",
  useHandleSearch: true,
});

/**
 * Complete Audit
 */
export const completeAuditsThunk = createDynamicThunk({
  typePrefix: "audits/completeAuditsThunk",
  endpoint: "/audits/updateMul",
  method: "POST",
});

/**
 * Delete Audit
 */
export const deleteAuditsThunk = createDynamicThunk({
  typePrefix: "audits/deleteAuditsThunk",
  endpoint: "/audits/deleteMul",
  method: "POST",
});

/**
 * Soft-delete Audit
 */
export const softDeleteAuditsThunk = createDynamicThunk({
  typePrefix: "audits/softDeleteAuditsThunk",
  endpoint: "/audits/softDeleteMul",
  method: "POST",
});

/**
 * Fetch Processes by Deparmtent
 */
export const fetchProcessesByDeptThunk = createDynamicThunk({
  typePrefix: "audits/fetchProcessesByDeptThunk",
  endpoint: "/processes/findProcessesByDept",
  method: "POST",
});

/**
 * Fetch AuditForm by Process
 */
export const fetchAuditFormByProcessThunk = createDynamicThunk({
  typePrefix: "auditForms/fetchAuditFormByProcessThunk",
  endpoint: "/auditForms/findAuditFormByProcess",
  method: "POST",
});

/**
 * Fetch User by role and client
 */
export const fetchUserByRoleAndClientThunk = createDynamicThunk({
  typePrefix: "users/fetchUserByRoleAndClientThunk",
  endpoint: "/users/findUserByRoleAndClient",
  method: "POST",
});

/**
 * Fetch Clients
 */
export const fetchClientsThunk = createDynamicThunk({
  typePrefix: "fetchClientsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Fetch Departments
 */
export const fetchDepartmentsThunk = createDynamicThunk({
  typePrefix: "fetchDepartmentsThunk",
  endpoint: "/fetchWithoutPagination",
  method: "POST",
});

/**
 * Download all
 */
// export const downloadAllThunk = createDynamicThunk({
//   typePrefix: "downloadAll",
//   endpoint: "/downloadAll",
//   method: "POST",
//   responseType: "blob",
// });
export const downloadAllThunk = createAsyncThunk(
  "downloadAll",
  async (payload = {}, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState();

      const { role, accessToken, accessTokenExpiresOn } = auth;

      const { endpointOverride, headers, ...dataToSend } = payload;

      const response = await APICaller(
        role,
        accessToken,
        endpointOverride || "/downloadAll",
        "POST",
        dataToSend,
        "blob",
      );

      // Background export response comes as JSON Blob
      if (response instanceof Blob) {
        const contentType = response.type || "";

        if (
          contentType.includes("application/json") ||
          contentType.includes("text/plain")
        ) {
          const text = await response.text();

          try {
            return JSON.parse(text);
          } catch {
            return {
              message: text,
            };
          }
        }
      }

      // Normal/direct Excel export
      return response;
    } catch (error) {
      let errorData = error?.response?.data;

      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text();

          try {
            errorData = JSON.parse(text);
          } catch {
            errorData = { message: text };
          }
        } catch {
          errorData = null;
        }
      }

      return rejectWithValue(
        errorData || {
          message:
            error instanceof Error ? error.message : "Unable to export data",
        },
      );
    }
  },
);

export const submitFeedbackThunk = createDynamicThunk({
  typePrefix: "audits/submitFeedbackThunk",
  endpoint: "/audits/submitFeedback",
  method: "PUT",
});

export const fetchUserInfoThunk = createDynamicThunk({
  typePrefix: "fetchUserInfoThunk",
  endpoint: "/users",
  method: "GET",
});

export const updateFormContentThunk = createDynamicThunk({
  typePrefix: "audits/updateFormContentThunk",
  endpoint: "/audits/updateFormContent",
  method: "PUT",
});

export const saveAuditThunk = createDynamicThunk({
  typePrefix: "audits/saveAuditThunk",
  endpoint: "/audits",
  method: "POST",
});

export const getAuditDetailThunk = createDynamicThunk({
  typePrefix: "audits/getAuditDetailThunk",
  endpoint: "/audits",
  method: "GET",
});

export const getAuditFormDetailThunk = createDynamicThunk({
  typePrefix: "auditForms/getAuditFormDetailThunk",
  endpoint: "/auditForms",
  method: "GET",
});

/**
 * Get Export Status
 */
export const getExportStatusThunk = createDynamicThunk({
  typePrefix: "exports/getExportStatusThunk",
  endpoint: "/exports",
  method: "POST",
});
